import { useQuery } from "@tanstack/react-query";

import { BackfillStatus } from "@protos/ai/v1/tasks";
import { authGet } from "@shared/api";

import { useOrgAssertDefined } from "../useOrgAssertDefined";

export const useFetchAiTaskState = () => {
  const org = useOrgAssertDefined();

  return useQuery({
    queryKey: ["aiTaskStatus", org.id],
    queryFn: () => fetchAiTaskWaitTime(org.id),
  });
};

const fetchAiTaskWaitTime = async (
  deploymentId: number
): Promise<BackfillStatus> => {
  return authGet<BackfillStatus>(`/api/ai/${deploymentId}/info`).then(
    (response) => BackfillStatus.fromJSON(response)
  );
};
